module.exports = "https://r.zoocdn.com/_next/static/images/buying-large-802dc4466d93b2eb116912b34fd5763c.svg";